import { useState } from 'react';
import { ArrowRight, Check, AlertCircle } from 'lucide-react';
import { frontOs } from '../../content/agencyCopy';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Waitlist({ product = 'front-os', source = 'front-os-page' }) {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setErrorMsg('Please enter a valid email address.');
      setState('error');
      return;
    }
    setState('submitting');
    setErrorMsg('');
    try {
      const res = await fetch(`${API}/api/waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product, email, source }),
      });
      if (!res.ok) throw new Error(String(res.status));
      setState('success');
    } catch {
      setErrorMsg(frontOs.waitlist.error);
      setState('error');
    }
  };

  if (state === 'success') {
    return (
      <div
        className="flex items-center gap-3 p-5"
        style={{
          background: 'var(--fa-signal-wash)',
          borderLeft: '3px solid var(--fa-signal)',
        }}
        role="status"
      >
        <Check size={18} style={{ color: 'var(--fa-signal)' }} />
        <span className="text-[15px]" style={{ color: 'var(--fa-ink)' }}>
          {frontOs.waitlist.success}
        </span>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-3" noValidate>
      <div
        className="flex flex-col sm:flex-row gap-2"
        style={{ maxWidth: '480px' }}
      >
        <label className="sr-only" htmlFor="waitlist-email">Email</label>
        <input
          id="waitlist-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={frontOs.waitlist.placeholder}
          className="flex-1 px-4 py-3 text-[15px]"
          style={{
            background: 'var(--fa-paper)',
            border: '1px solid var(--fa-rule)',
            color: 'var(--fa-ink)',
            borderRadius: 4,
            outline: 'none',
          }}
          onFocus={(e) => (e.target.style.borderColor = 'var(--fa-signal)')}
          onBlur={(e) => (e.target.style.borderColor = 'var(--fa-rule)')}
          disabled={state === 'submitting'}
        />
        <button
          type="submit"
          className="fa-btn-signal"
          disabled={state === 'submitting'}
          style={{ opacity: state === 'submitting' ? 0.7 : 1 }}
        >
          {state === 'submitting' ? 'Joining…' : frontOs.waitlist.cta}
          {state !== 'submitting' && <ArrowRight size={16} />}
        </button>
      </div>
      {state === 'error' && (
        <div
          className="flex items-start gap-2 text-[13px]"
          style={{ color: 'var(--fa-ink)' }}
          role="alert"
        >
          <AlertCircle size={14} style={{ color: 'var(--fa-signal)', marginTop: 2 }} />
          {errorMsg}
        </div>
      )}
    </form>
  );
}
